/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".visit-dialog-content[_ngcontent-%COMP%]{width:20.8333333333vw}[_nghost-%COMP%]     .form-legend{margin:0 auto}"];
export { styles as styles };
